import { render, staticRenderFns } from "./FanList.vue?vue&type=template&id=bf83db48&scoped=true&"
import script from "./FanList.vue?vue&type=script&lang=js&"
export * from "./FanList.vue?vue&type=script&lang=js&"
import style0 from "./FanList.vue?vue&type=style&index=0&id=bf83db48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf83db48",
  null
  
)

export default component.exports